module.exports = __webpack_public_path__ + "img/noCart.feb5c6ae.png";